import * as React from "react";
// import SoundButton from "src/components//Buttons/SoundButton";
import FooterButton from "src/components/Buttons/FooterButton";
import { IFooterComponent, IText } from "src/ScrollyInterface";
import { getParamSize, setStyles } from "src/shared/breakpoints";
import "./Footer.scss";

const footerComponent = (props: IFooterComponent) => {
  const {
    bounce,
    breakpoint,
    contentId,
    elemNumber,
    footer,
    // muted,
    onScrollClicked,
    // onSoundClicked,
    showSideDrawer,
    videoLoaded
  } = props;

  const SDopenStyle = showSideDrawer ? { zIndex: -1 } : {};

  const generateStyles = (defaultContent: IText) => {
    const fontSizeNo =
      defaultContent && defaultContent.font_size
        ? getParamSize(defaultContent.font_size)
        : 16;
    return {
      fontSize:
        defaultContent && defaultContent.font_size
          ? setStyles(
              {
                default: defaultContent.font_size,
                mobileLg:
                  fontSizeNo && fontSizeNo > 32
                    ? "32px"
                    : defaultContent.font_size,
                mobileMd:
                  fontSizeNo && fontSizeNo > 20
                    ? "20px"
                    : defaultContent.font_size
              },
              breakpoint
            )
          : fontSizeNo,
      letterSpacing:
        defaultContent && defaultContent.letter_spacing
          ? setStyles(
              {
                default:
                  defaultContent && defaultContent.letter_spacing
                    ? defaultContent.letter_spacing
                    : "",
                tabletSm: "0px"
              },
              breakpoint
            )
          : "0px"
    };
  };

  const styles = generateStyles(footer);

  return (
    <div className="Footer-container" style={SDopenStyle}>
      <div className="Footer-subcontainer">
        <div className="Footer-block">
          <FooterButton
            bounce={bounce}
            styles={styles}
            contentId={contentId}
            elemNumber={elemNumber}
            footer={footer}
            onScrollClicked={onScrollClicked}
            videoLoaded={videoLoaded}
          />
          {/* <SoundButton muted={muted} onSoundClicked={onSoundClicked} /> */}
        </div>
      </div>
    </div>
  );
};

export default footerComponent;



// WEBPACK FOOTER //
// ./src/components/Marginals/Footer.tsx